<template>
  <v-container fluid>
    <v-card class="v-card--material pa-3 mt-4 rounded-lg" elevation="2">
      <v-row no-gutters>
        <v-col cols="12" lg="2" class="my-0 py-0">
          <div class="d-flex grow flex-wrap">
            <div class="ml-2">
              <div class="font-weight-regular headline text-decoration-underline text-capitalize">
                Enquiry Listing
              </div>
            </div>
          </div>
        </v-col>
        <v-col cols="12">
          <form @submit.prevent="() => {
            ; (getYetToCallAlertStripCount = false),
              (getTodayFollowUpCount = false),
              (page = 1)
          }
          ">
            <v-row>
              <v-col cols="12" sm="12" md="6" lg="2" class="pt-2 mt-3">
                <custom-date-picker label="From" dense prepend-icon="mdi-calendar" :maxToDate="maxToDate"
                  v-model="filter.fromDate" required />
              </v-col>
              <v-col cols="12" sm="12" md="6" lg="2" class="pt-2 mt-3">
                <custom-date-picker label="To" dense prepend-icon="mdi-calendar" :minToDate="filter.fromDate"
                  v-model="filter.toDate" required />
              </v-col>
              <v-col cols="12" sm="12" md="6" lg="2" class="pt-0 mt-0">
                <v-select :items="subStageArray" v-model="selectedSpancoStatus" item-text="statusName"
                  item-value="statusName" v-on:change="spancoAssignFilter" label="Filter By Spanco Status" clearable />
              </v-col>
              <v-col cols="12" sm="12" md="6" lg="2" class="pt-0 mt-0">
                <v-select :items="spancoArray" v-model="selectedSpancoName" item-text="name" item-value="name"
                  label="Filter By Spanco Sub Status" clearable />
              </v-col>
              <v-col cols="2" class="pt-0 mt-0">
                <v-select :items="assignedToFilterArray" v-model="assignedToFilterValue" item-text="displayName"
                  item-value="id" label="Filter By Assigned To" clearable />
              </v-col><v-col cols="2" class="pt-0 mt-0">
                <v-select :items="classCategoryData" v-model="classCategoryId" item-text="category"
                  item-value="category" label="Filter By Student class category" clearable />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="4">
                <v-text-field :class="{
                  'mr-0': $vuetify.breakpoint.xs,
                  'mr-5': $vuetify.breakpoint.smAndUp
                }" v-model="search" append-icon="mdi-magnify" class="ml-auto mb-2" dense
                  label="Search using Enquiry Code/Mobile Number" hide-details="true" />
              </v-col>
              <v-col cols="3" class="pt-0 mt-0" v-if="sourceCardAccess">
                <v-select :items="sourceCategoryData" v-model="sourceCard" item-text="name" item-value="name"
                  label="Filter By Source Cards" />
              </v-col>
              <v-col cols="3" class="pt-0 mt-0">
                <v-switch v-model="followUpSwitch" label="FollowUp-Only" color="primary" />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" align="right" lg="12" md="12" sm="6">
                <div>
                  <v-btn v-if="$vuetify.breakpoint.smAndUp" id="otherClick" @click="applySelectFilter($event)"
                    class="mr-2 ml-2" color="success" elevation="1" type="submit">
                    <v-icon left size="18"> mdi-text-box-check-outline </v-icon>
                    Apply
                  </v-btn>
                  <v-btn v-else id="otherClick" v-on:click="select($event)" class="mr-4" color="success" elevation="1"
                    type="submit">
                    <v-icon size="18"> mdi-text-box-check-outline </v-icon>
                  </v-btn>
                  <v-btn v-if="$vuetify.breakpoint.smAndUp" elevation="1" type="reset" @click="resetAll()">
                    <v-icon left size="18"> mdi-restart</v-icon>
                    Reset
                  </v-btn>
                  <v-btn v-else elevation="1" type="reset" @click="resetAll()">
                    <v-icon size="18"> mdi-restart</v-icon>
                  </v-btn>
                  <v-btn class="ml-2" :disabled="!(enquiryData.length > 0)" @click="exportAllDataInCsv()"
                    v-if="$vuetify.breakpoint.smAndUp" color="primary" elevation="1">
                    <v-icon left size="18">mdi-download</v-icon>
                    Export All
                  </v-btn>

                  <v-btn v-else class="ml-4" :disabled="!(enquiryData.length > 0)" @click="exportToCSV()"
                    color="primary" elevation="1">
                    <v-icon size="18">mdi-download</v-icon>
                  </v-btn>
                  <v-btn class="ml-2" @click="(qrCodeDialog = true), generateQRcode()" :disabled="!this.franchiseeID"
                    :class="{ 'mt-2': $vuetify.breakpoint.xs }" color="accent" elevation="1">
                    <v-icon left>mdi-qrcode-scan</v-icon>
                    Show QR Code
                  </v-btn>
                </div>
              </v-col>
            </v-row>
            <v-card-text class="pt-0 pr-1" :class="{
              'd-block py-3': $vuetify.breakpoint.xs,
              'd-flex align-center': $vuetify.breakpoint.smAndUp
            }">
              <v-dialog width="400px" max-width="1000px" v-model="qrCodeDialog" persistent
                :class="{ 'is-active': enableEnquiryModal }">
                <v-card>
                  <v-card-title>
                    <span class="headline">QR Code</span>
                  </v-card-title>
                  <v-btn class="mt-8" color="error" elevation="1" small fab absolute top right
                    @click="; (qrCodeDialog = false), resetEnquiry()">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                  <v-card-text>
                    <v-container>
                      <form @submit.prevent="studEnquiry">
                        <v-row>
                          <v-col cols="12" md="12" lg="12" sm="12" xs="12">
                            <div style="width:100%;text-align:center;">
                              <img v-if="qrCodeUrl !== ''" :src="qrCodeUrl" alt="QR Code" />
                              <a hidden id="download"></a>
                              <v-spacer></v-spacer>
                              <v-btn class="mb-2" v-if="qrCodeUrl !== ''" @click="downloadQRcode()" color="success">
                                <v-icon>mdi-arrow-down</v-icon>
                                Download QR
                              </v-btn>
                            </div>
                          </v-col>
                        </v-row>
                      </form>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-dialog>
            </v-card-text>
          </form>
        </v-col>
      </v-row>
      <v-divider class="my-0" />
      <v-skeleton-loader v-if="skeletonLoaderFlag" type="table-thead, table-tbody"></v-skeleton-loader>
      <v-data-table v-else :single-expand="true" :show-expand="showExpand" item-key="srno" :headers="headers"
        :items="enquiryData" disable-pagination :hide-default-footer="true" id="TargetID">
        <template v-slot:item.franchiseeName="{ item }">
          <span>{{ item.franchiseeName || '-' }}</span>
        </template>

        <template v-slot:item.assignedToID="{ item }">
          <span>{{ item.currentAssignedTo }}</span>
        </template>
        <template v-slot:item.enquiryCode="{ item }">
          <span>{{ item.enquiryCode || '-' }}</span>
        </template>
        <template v-slot:item.fatherName="{ item }">
          <span>{{ item.fatherName ? item.fatherName : item.motherName }}</span>
        </template>
        <template v-slot:item.studentFirstName="{ item }">
          <span>{{ item.studentFirstName || '-' }}</span>
        </template>
        <template v-slot:item.fatherMobile="{ item }">
          <span>{{ item.fatherMobile || '-' }}</span>
        </template>
        <template v-slot:item.studentClassName="{ item }">
          <span>{{ item.studentClass.name || '-' }}</span> </template><template
          v-slot:item.studentClassCategory="{ item }">
          <span>{{ item.studentClass.category || '-' }}</span>
        </template>
        <template v-slot:item.franchiseeCompanyName="{ item }">
          <span>{{ item.franchisee ? item.companyName : '-' }}</span>
        </template>
        <template v-slot:item.spancoStage="{ item }">
          <span>{{ item.spancoStage }}</span>
        </template>
        <template v-slot:item.studentName="{ item }">
          <span>{{ item.studentName }}</span>
        </template>
        <template v-slot:item.sourceID="{ item }">
          {{ getSourceName(item.sourceID) }}
        </template>
        <template v-slot:item.actions="{ item }" v-if="isWrite">
          <div v-if="item.spancoStatus != 'On Board'">
            <div v-if="item.spancoStatus != 'Negotiate' && item.spancoStatus != 'Close'
            ">
              <router-link :to="{
                name: 'EditEnquiries',
                params: {
                  endpointID: item.id,
                  enquiryCode: item.enquiryCode,
                  radio: radio,
                  admin: isSuperAdmin,
                  spancoStatus2: item.spancoStatus,
                  spancoStage2: item.spancoStage
                }
              }" :event="!item.enrollmentCode ? 'click' : ''">
                <v-btn outlined :disabled="item.enrollmentCode !== null ? true : false"
                  class="px-2 ml-1 white--text ma-1" color="success" min-width="0" small>
                  Edit
                </v-btn>
              </router-link>
            </div>
            <span>
              <router-link :to="{
                name: 'followupDetails',
                params: {
                  enquiryCode: item.enquiryCode,
                  spancoStatus1: item.spancoStatus,
                  admin: isSuperAdmin,
                  spancoStage1: item.spancoStage
                }
              }" target="_blank">
                <v-btn small outlined class="px-2 ml-1 ma-1" color="pink">Proceed to Followup
                </v-btn>
              </router-link>
            </span>
          </div>
        </template>

        <template v-slot:expanded-item="{ headers, item }">
          <td :colspan="headers.length">
            <div class="d-flex justify-space-around">
              <span><b>Parent Mobile No : </b> {{ item.fatherMobile }}</span>
              <span><b>Parent E-mail Address : </b> {{ item.fatherEmailID }}</span>
              <span><b>Old Enquiry Code : </b> {{ item?.enquiryCodes?.[0]?.oldEnquiryCodes ? item?.enquiryCodes?.[0]?.oldEnquiryCodes : '-' }}</span>
            </div>
          </td>
        </template>
        <template v-slot:no-data>
          <v-card-subtitle class="d-flex justify-center">No Data Available</v-card-subtitle>
        </template>
      </v-data-table>
      <v-col v-if="enquiryData.length != 0">
        <v-row>
          <v-col cols="4" sm="3">
            <v-select v-model="pageSize" :items="pageSizes" label="Items per Page"
              @change="handlePageSizeChange"></v-select>
          </v-col>
          <v-col cols="12" sm="9">
            <v-pagination v-model="page" :length="totalPages" :total-visible="10"
              @input="handlePageChange"></v-pagination>
          </v-col>
        </v-row>
      </v-col>
    </v-card>
  </v-container>
</template>
<script>
import constants from '@/utils/constants'
import CustomDatePicker from '@/components/template/CustomDatePicker'
import { mapGetters } from 'vuex'
import moment from 'moment'
import Utils from '@/utils'
import ExportUtility from '@/utils/exportUtility'
import _ from 'lodash'
import QRCode from 'qrcode'
import Stores from '@/stores'
export default {
  name: 'enquiry-listing',
  props: [
    'getTodaysFollowUpCount',
    'isFromYetToCallAlertStrip',
    'radio2',
    'fromDate',
    'applyFilter'
  ],
  components: {
    CustomDatePicker
  },
  data () {
    return {
      academicYearID: '',
      franchiseeID: '',
      assignedToFilterValue: '',
      showExpand: false,
      classCategoryId: '',
      assignedToFilterArray: [],
      subStageArray: [],
      selectedSpancoStatus: '',
      selectedSpancoName: '',
      isWrite: false,
      // searchDialog: false,
      qrCodeDialog: false,
      item: 0,
      classCategoryData: [],
      filterData: [],
      searchTerm: '',
      radio: 'all',
      total: 0,
      search: '',
      isPaginationApply: true,
      page: 1,
      totalPages: 0,
      totalItems: 0,
      pageSize: 10,
      pageSizes: [5, 10, 50, 100],
      findType: [
        { text: 'Mobile Number', value: 'studentmobile' },
        { text: 'Student Name', value: 'studentname' }
        // { text: 'Enquiry Code', value: 'enquiryCode' }
      ],
      headers: [
        // { text: '', value: 'data-table-expand', align: 'center', sortable: false },
        { text: 'Sr No', value: 'srno', align: 'center', sortable: true },
        // { text: 'Action', value: 'actions', align: 'center', sortable: false },
        // { text: 'Sr No', value: 'srno', align: 'center', sortable: true },
        { text: 'Enquiry Code', sortable: true, value: 'enquiryCode' },
        {
          text: 'Enquiry Assigned To',
          value: 'currentAssignedTo',
          sortable: true
        },
        { text: 'Parent Name', sortable: true, value: 'fatherName' },
        { text: 'Student Name', sortable: true, value: 'studentFirstName' },
        // { text: 'Parent Mobile', sortable: false, value: 'fatherMobile' },
        // { text: 'Student Name', value: 'studentName', sortable: true },
        { text: 'Opting Class', value: 'studentClass.name', sortable: true },
        {
          text: 'Class category',
          value: 'studentClass.category',
          sortable: true
        },

        // { text: 'Center Name', value: 'franchiseeName', sortable: true },

        {
          text: 'Franchisee Name',
          value: 'franchisee.companyName',
          sortable: true
        },
        {
          text: 'Spanco status/sub status',
          value: 'spancoStage',
          sortable: true
        },
        // { text: 'Spanco sub status', value: 'spancoStatus', sortable: true },
        {
          text: 'Source',
          value: 'sourceID',
          align: 'center',
          sortable: false
        },
        // {
        //   text: 'Zone',
        //   value: 'franchisee.region',
        //   sortable: false
        // },
        { text: 'Action', value: 'actions', align: 'center', sortable: false },
        { text: 'Date of Enquiry', value: 'dateOfEnquiry', sortable: true },
        // { text: 'Last Follow Up', value: 'followUpDate', sortable: true },
        { text: 'Next Follow Up', value: 'followUpDate', sortable: true }
      ],
      stdEnqModalHeaders: [
        { text: 'Sr No', value: 'srno', sortable: true },
        { text: 'Enquiry Code', value: 'enquiryCode', sortable: true },
        { text: 'Enquiry Date', value: 'createdAt', sortable: true },
        { text: 'Student Name', value: 'studentFirstName', sortable: true },
        { text: 'Opting Class', value: 'studentClassName', sortable: true },
        {
          text: 'Class category',
          value: 'studentClassCategory',
          sortable: true
        },
        { text: 'Parent Name', value: 'fatherName', sortable: true },
        { text: 'Parent Mobile Number', value: 'fatherMobile', sortable: true },
        { text: 'Action', value: 'actions', align: 'center' }
      ],
      isSuperAdmin: false,
      enableEnquiryModal: false,
      enableSearchModal: false,
      enquiryData: [],
      findData: [],
      enquiryTableData: [],
      findDataArr: [],
      searchKey: '',
      spancoArray: [],
      selectedEnquiry: [],
      selectedEnquiryCode: '',
      selectedAssignTo: '',
      selectedEnquiryId: '',
      inProgress: false,
      findEnquiry: {
        academicYearID: '',
        searchType: 'studentmobile',
        searchKey: ''
      },
      filter: {
        fromDate: this.fromDate ? this.fromDate : moment().format('YYYY-MM-DD'),
        toDate: moment().format('YYYY-MM-DD'),
        academicYearID: '',
        stage: 'All'
      },
      maxToDate: moment().format('YYYY-MM-DD'),
      academicYears: [],
      stages: [],
      searchEnquiryObj: {
        academicYearID: '',
        searchType: 'studentmobile',
        searchKey: ''
      },
      academicYearFilterID: '',
      spancoDefaultStatus: '',
      spancoDefaultStage: '',
      reportData: [],
      modules: {
        parentContact: this.checkModuleAccess('parentContact')
      },
      alert: true,
      getAllCount: null,
      qrCodeUrl: '',
      qrCodeColor: '#000000',
      qrCodeWidth: 450,
      mobileDataHeight: null,
      sizeOptions: [
        {
          id: 150,
          value: '150 px'
        },
        {
          id: 250,
          value: '250 px'
        },
        {
          id: 350,
          value: '350 px'
        },
        {
          id: 450,
          value: '450 px'
        },
        {
          id: 500,
          value: '500 px'
        }
      ],
      isInput: false,
      sourceCategoryData: [
        {
          id: 1,
          name: 'QR Leads'
        },
        { id: 2, name: 'WhatsApp Leads' },
        { id: 3, name: 'Manual Leads' },
        { id: 4, name: 'Facebook Leads' },
        { id: 5, name: 'Intelllitots Website Leads' }
      ],
      sourceCard: '',
      sourceCardAccess: false,
      followUpSwitch: false,
      getTodayFollowUpCount: null,
      getYetToCallAlertStripCount: null,
      isApply: false,
      isLocalStorageFlag: false,
      isDateFilterApplyOnDashboard: false,
      isEnquiryListingPage: true,
      franchiseeWatch: 0,
      academicWatch: 0,
      skeletonLoaderFlag: false
    }
  },
  computed: {
    ...mapGetters({
      franchisee: 'getFranchisee',
      academicYear: 'getAcademicYear'
    })
  },
  watch: {
    selectedSpancoStatus: function (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.selectedSpancoName = ''
      }
    },
    franchisee: async function (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.franchiseeWatch++
        if (this.franchiseeWatch > 1) {
          this.isDateFilterApplyOnDashboard = true
        }
        await this.onFranchiseeChange()
        if (!this.franchiseeID) {
          this.franchiseeID = newVal.id
        }
      }
    },
    academicYear: async function (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.academicWatch++
        if (this.academicWatch > 1) {
          this.isDateFilterApplyOnDashboard = true
        }
        await this.onFranchiseeChange()
        if (!this.academicYearID) {
          this.academicYearID = newVal.id
        }
      }
    },
    franchiseeID: async function (newVal, oldVal) {
      if (newVal !== oldVal) {
        if (this.selectedSpancoStatus && this.selectedSpancoName && !this.isDateFilterApplyOnDashboard) {
          await this.getEnquiryStagesReportFilter(this.selectedSpancoStatus, this.selectedSpancoName)
        } else if (this.selectedSpancoStatus && !this.isDateFilterApplyOnDashboard) {
          await this.getEnquiryStagesReportFilter(this.selectedSpancoStatus, '')
        } else {
          await this.getEnquiry()
        }
      }
    },
    academicYearID: async function (newVal, oldVal) {
      if (newVal !== oldVal) {
        if (this.selectedSpancoStatus && this.selectedSpancoName && !this.isDateFilterApplyOnDashboard) {
          await this.getEnquiryStagesReportFilter(this.selectedSpancoStatus, this.selectedSpancoName)
        } else if (this.selectedSpancoStatus && !this.isDateFilterApplyOnDashboard) {
          await this.getEnquiryStagesReportFilter(this.selectedSpancoStatus, '')
        } else {
          await this.getEnquiry()
        }
      }
    }
  },
  async created () {
    this.skeletonLoaderFlag = true
    this.getTodayFollowUpCount = this.getTodaysFollowUpCount
    this.getYetToCallAlertStripCount = this.isFromYetToCallAlertStrip
    await this.getEnquiryStages()
    let getDashboardEnquiryFilter = JSON.parse(localStorage.getItem('dashboardEnquiryFilter'))
    await this.checkDateFilterOnDashboard(getDashboardEnquiryFilter)
    await this.onFranchiseeChange()
    if (localStorage.getItem('dashboardEnquiryFilter')) {
      this.inProgress = true
    }
    if (this.getYetToCallAlertStripCount || this.getTodayFollowUpCount) {
      this.getEnquiry()
      this.skeletonLoaderFlag = false
    } else {
      await this.getStudentClassCategory()
      await this.getEnquiryAssignee()
      // await this.getResults()
      let checkAccess = await this.checkModuleAccess('parentContact')
      if (checkAccess) {
        this.showExpand = true
      }
      this.sourceCardAccess = await this.checkModuleAccess('sourceCardAccess')
      this.isSuperAdmin = Utils.helper.isSuperAdmin()
      this.isWrite = Utils.helper.getIsWriteFun(this.$route)
      this.spancoDefaultStatus = constants.SPANCOSTATUS.DEFAULT
      this.spancoDefaultStage = constants.SPANCOSTATUS.DEFAULTSTAGE
      this.filter.fromDate = this.$store.state.enquiryFilterFromDate
        ? this.$store.state.enquiryFilterFromDate
        : moment().format('YYYY-MM-DD')
      if (typeof getDashboardEnquiryFilter !== 'undefined' && getDashboardEnquiryFilter) {
        this.filter.fromDate = getDashboardEnquiryFilter.fromDate
          ? getDashboardEnquiryFilter.fromDate
          : this.filter.fromDate
        this.filter.toDate = this.$store.state.enquiryFilterToDate
          ? this.$store.state.enquiryFilterToDate
          : moment().format('YYYY-MM-DD')
        this.filter.toDate = getDashboardEnquiryFilter.toDate
          ? getDashboardEnquiryFilter.toDate
          : this.filter.toDate
        this.selectedSpancoStatus = getDashboardEnquiryFilter.spancoStatus ? getDashboardEnquiryFilter.spancoStatus : ''
        await this.spancoAssignFilter()
        this.selectedSpancoName = (typeof getDashboardEnquiryFilter.spancoName !== 'undefined' && getDashboardEnquiryFilter.spancoName) ? getDashboardEnquiryFilter.spancoName : ''
        this.sourceCard = getDashboardEnquiryFilter.sourceName || this.sourceCard
        this.followUpSwitch = getDashboardEnquiryFilter.followUpOnly || this.followUpOnly
      }
      if (getDashboardEnquiryFilter && !getDashboardEnquiryFilter.isApplyFilter) {
        this.isApply = false
        if (!this.isDateFilterApplyOnDashboard) {
          if (this.selectedSpancoStatus && this.selectedSpancoName) {
            await this.getEnquiryStagesReportFilter(this.selectedSpancoStatus, this.selectedSpancoName)
            this.skeletonLoaderFlag = false
          } else if (this.selectedSpancoStatus) {
            await this.getEnquiryStagesReportFilter(this.selectedSpancoStatus, '')
            this.skeletonLoaderFlag = false
          }
        } else {
          this.isApply = true
          await this.getEnquiry()
          try {
            this.isLoading = true
            const { data: questions } = await http.get(
              `${constants.API_URL}/api/enquiry-questions`
            )
            this.stages = questions.filter((obj) => obj.type === 'INTEREST_TYPE')
            this.skeletonLoaderFlag = false
          } catch (e) {
            const errorMessage = (e && e.response && e.response.data.message) || e.message
            console.log(errorMessage)
            this.skeletonLoaderFlag = false
          }
        }
      } else {
        this.isApply = true
        await this.getEnquiry()
        try {
          this.isLoading = true
          const { data: questions } = await http.get(
            `${constants.API_URL}/api/enquiry-questions`
          )
          this.stages = questions.filter((obj) => obj.type === 'INTEREST_TYPE')
          this.skeletonLoaderFlag = false
        } catch (e) {
          this.skeletonLoaderFlag = false
          const errorMessage = (e && e.response && e.response.data.message) || e.message
          console.log(errorMessage)
        }
      }
    }
    if (localStorage.getItem('dashboardEnquiryFilter')) {
      this.inProgress = false
      localStorage.removeItem('dashboardEnquiryFilter')
    }
  },
  methods: {
    checkDateFilterOnDashboard: function (dashboardFilter) {
      this.isDateFilterApplyOnDashboard = false
      if (dashboardFilter) {
        let fromDate = moment().format('YYYY-MM-DD')
        let toDate = moment().format('YYYY-MM-DD')
        if (!_.isNull(dashboardFilter.fromDate) && !_.isNull(dashboardFilter.toDate)) {
          if (dashboardFilter.fromDate !== fromDate || dashboardFilter.toDate !== toDate) {
            this.isDateFilterApplyOnDashboard = true
          }
        }
        if (dashboardFilter.isApplyFilter) {
          this.isDateFilterApplyOnDashboard = true
        }
      }
      return true
    },
    checkModuleAccess: function (moduleName) {
      return Utils.helper.checkAccessByModule(this.$route, moduleName)
    },
    select: function (event) {
      let targetId = event.currentTarget.id
      if (targetId === 'otherClick') {
        this.enquiryStageID = ' '
      }
    },
    applySelectFilter: function (event) {
      let targetId = event.currentTarget.id
      if (targetId === 'otherClick') {
        this.enquiryStageID = ' '
      }
      this.page = 1
      this.getEnquiry()
    },
    getFranchiseeDataFromIndexDB: function () {
      let obj = Stores.user.franchisee
      return obj
    },
    onFranchiseeChange: async function () {
      if (!this.inProgress) {
        this.inProgress = true
        if (this.franchisee && this.franchisee.id) {
          this.franchiseeID = this.franchisee.id
        } else {
          let getFranchiseeData = this.getFranchiseeDataFromIndexDB()
          this.franchiseeID = (getFranchiseeData && getFranchiseeData.id) ? getFranchiseeData.id : ''
        }
        if (this.academicYear) {
          this.academicYearID = this.academicYear.id
        } else {
          this.academicYearID = ''
        }
        if (!this.franchiseeID) {
          Utils.helper.openDrawer(this)
        } else {
          Utils.helper.openDrawer(this, false)
        }

        await this.customFilter()
        if (this.radio2) {
          this.radio = this.radio2
        }

        this.inProgress = false
      }
    },
    getStudentClassCategory: async function () {
      try {
        this.isLoading = true
        let { data } = await http.get(
          `${constants.API_URL}/api/student/class/category`
        )
        this.classCategoryData = data
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.$dialog.error({
          text: errorMessage,
          title: 'Error'
        })
      } finally {
        this.isLoading = false
      }
    },

    getEnquiryStagesReportFilter: async function (spancoStatus, subStatus) {
      try {
        this.skeletonLoaderFlag = true
        this.isEnquiryListingPage = true
        this.isApply = false
        this.cardselected = true
        this.enquiryData = []
        if (this.academicYear && this.academicYear.id) {
          if (this.franchisee && this.franchisee.id) {
            this.franchiseeID = this.franchisee.id
          } else {
            let getFranchiseeData = this.getFranchiseeDataFromIndexDB()
            this.franchiseeID = (getFranchiseeData && getFranchiseeData.id) ? getFranchiseeData.id : ''
          }
          this.isLoading = true
          const formData = {
            academicYearID: this.academicYear.id,
            franchiseeID: this.franchiseeID,
            spancoStatus: spancoStatus,
            subStatus: subStatus
          }
          const result = await http.post(
            `${constants.API_URL}/api/getenquirystagesreportfilter?page=${this.page - 1
            }&size=${this.pageSize}&search=${this.search}`,
            formData
          )
          this.enquiryData = result.data.rows
          this.totalPages = result.data.totalPages
          this.totalItems = result.data.totalItems
          this.total = this.enquiryData.length
          if (this.getYetToCallAlertStripCount) {
            this.spancoDefaultStage = 'Yet_to_Call'
            // this.isWrite = true
          }
          this.enquiryData.filter((item, index) => {
            item.srno = this.pageSize * (this.page - 1) + index + 1
            item.dateOfEnquiry = moment(item.dateOfEnquiry).format(
              'MMMM Do YYYY, HH:mm a'
            )
            item.createdAt = moment(item.createdAt).format(
              'MMMM Do YYYY, HH:mm a'
            )

            let spancoName = item.spancoStatus
              ? item.spancoStatus
              : this.spancoDefaultStatus

            let spancoStg = item.enquiryStage?.name || this.spancoDefaultStage
            item.spancoStage = spancoName + ' - ' + spancoStg

            item.updatedAt = moment(item.updatedAt).format('D-MMM-YYYY HH:mm')

            item.studentName = item.studentFirstName
            if (item.studentMiddleName) {
              item.studentName = item.studentName + ' ' + item.studentMiddleName
            }
            if (item.studentLastName) {
              item.studentName = item.studentName + ' ' + item.studentLastName
            }
            if (item.enquiryStage) {
              item.status = item.enquiryStage.name
            } else if (item.enrollmentCode) {
              item.status = 'Admission'
            } else if (item.ApplicationCode) {
              item.status = 'Application'
            } else {
              item.status = 'Enquiry'
            }
            item.currentAssignedTo = item.user
              ? item.user.firstName + ' ' + item.user.lastName
              : 'No user is assigned'
          })
          this.spancoFilterArray = _.uniq(
            _.map(this.enquiryData, (a) => a.spancoStage)
          )

          this.enquiryData = this.enquiryData.map(({ spancoStatus, ...rest }) => rest)

          this.dataStore = this.enquiryData
          this.skeletonLoaderFlag = false
        }
      } catch (e) {
        this.skeletonLoaderFlag = false
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        return this.$dialog.error({
          text: errorMessage,
          title: 'Error'
        })
      }
    },
    getEnquiry: async function () {
      this.skeletonLoaderFlag = true
      this.isApply = true
      this.spancoFilterValue = ''
      this.spancoFilterArray = []
      try {
        this.cardselected = false
        if (!this.academicYearID && this.academicYear) {
          this.academicYearID = this.academicYear.id
        }
        if (this.academicYearID) {
          if (this.franchisee && this.franchisee.id) {
            this.franchiseeID = this.franchisee.id
          } else {
            let getFranchiseeData = this.getFranchiseeDataFromIndexDB()
            this.franchiseeID = (getFranchiseeData && getFranchiseeData.id) ? getFranchiseeData.id : ''
          }
          this.isLoading = true
          let filterData = {}
          if (this.search) {
            filterData = {
              franchiseeID: this.franchiseeID,
              academicYearID: this.academicYearID,
              stage: this.filter.stage,
              page: this.page - 1,
              size: this.pageSize,
              search: this.search
            }
          } else {
            filterData = {
              franchiseeID: this.franchiseeID,
              fromDate: this.filter.fromDate
                ? this.filter.fromDate
                : moment().format('YYYY-MM-DD'),
              toDate: this.filter.toDate
                ? this.filter.toDate
                : moment().format('YYYY-MM-DD'),
              academicYearID: this.academicYearID,
              stage: this.filter.stage,
              page: this.page - 1,
              size: this.pageSize,
              todaysFollowUpLead: false,
              followupOnly: this.followUpSwitch
            }
          }
          if (this.selectedSpancoStatus && this.selectedSpancoStatus !== 'All') {
            filterData.spancoStatus = this.selectedSpancoStatus
          }
          if (this.selectedSpancoName && this.selectedSpancoName !== 'All') {
            filterData.spancoName = this.selectedSpancoName
          }
          if (this.assignedToFilterValue) {
            filterData.assignedToID = this.assignedToFilterValue
          }
          if (this.classCategoryId) {
            filterData.studentClassCategory = this.classCategoryId
          }
          if (this.sourceCard) {
            filterData.sourceCard = this.sourceCard
          }
          if (this.getYetToCallAlertStripCount) {
            filterData.spancoStatus = 'Suspect'
            filterData.spancoName = 'Yet_to_Call'
            delete filterData.fromDate
            delete filterData.toDate
            this.spancoDefaultStatus = 'Suspect'
            this.spancoDefaultStage = 'Yet_to_Call'
            this.sourceCardAccess = true
          }
          if (this.getTodayFollowUpCount) {
            filterData.todaysFollowUpLead = true
            delete filterData.fromDate
            delete filterData.toDate
            this.sourceCardAccess = true
          }
          const result = await http.get(`${constants.API_URL}/api/enquiry`, {
            params: filterData
          })
          this.enquiryData = result.data.rows
          this.totalPages = result.data.totalPages
          this.totalItems = result.data.totalItems
          this.$store.commit('setEnquiryFilterFromDate', filterData.fromDate)
          this.$store.commit('setEnquiryFilterToDate', filterData.toDate)

          /** Store data */
          this.$store.commit('updateEnqFromDate', filterData.fromDate)
          this.$store.commit('updateEnqToDate', filterData.toDate)
          this.$store.commit('updateEnqSpancoStatus', this.selectedSpancoStatus)
          this.$store.commit('updateEnqSpancoSubStatus', this.selectedSpancoName)
          this.$store.commit('updateEnqSearchValue', this.search)
          this.$store.commit(
            'updateAssignedToSearchValue',
            this.assignedToFilterValue
          )
          this.$store.commit('updateStudentClassCategory', this.classCategoryId)

          /** ************ */
          this.searchTerm = null
          this.customFilter()
          this.enquiryData.forEach((Enq, index) => {
            Enq.srno = this.pageSize * (this.page - 1) + index + 1
            let spancoName = Enq.enquiryStage?.statusName || this.spancoDefaultStatus
            let spancoStg = Enq.enquiryStage?.name || this.spancoDefaultStage
            Enq.spancoStage = spancoName + ' - ' + spancoStg
            Enq.createdAt = moment(Enq.createdAt).format('D-MMM-YYYY HH:mm')
            Enq.updatedAt = moment(Enq.updatedAt).format('D-MMM-YYYY HH:mm')
            Enq.dateOfEnquiry = Enq.dateOfEnquiry
              ? moment(Enq.dateOfEnquiry).format('D-MMM-YYYY HH:mm')
              : '-'
            Enq.followUpDate = Enq.followUpDate
              ? moment(Enq.followUpDate).format('D-MMM-YYYY HH:mm')
              : '-'
            Enq.studentName = Enq.studentFirstName
            if (Enq.studentMiddleName) {
              Enq.studentName = Enq.studentName + ' ' + Enq.studentMiddleName
            }
            if (Enq.studentLastName) {
              Enq.studentName = Enq.studentName + ' ' + Enq.studentLastName
            }
            if (Enq.enquiryStage) {
              Enq.status = Enq.enquiryStage.name
            } else if (Enq.enrollmentCode) {
              Enq.status = 'Admission'
            } else if (Enq.ApplicationCode) {
              Enq.status = 'Application'
            } else {
              Enq.status = 'Enquiry'
            }
            Enq.currentAssignedTo = Enq.user
              ? Enq.user.firstName + ' ' + Enq.user.lastName
              : 'No user is assigned'
          })
          if (this.radio === 'withMCBCode') {
            this.filterData = _.filter(this.filterData, 'enquiryCodeMCB')
          } else if (this.radio === 'withoutMCBCode') {
            this.filterData = _.filter(this.filterData, [
              'enquiryCodeMCB',
              null
            ])
          }

          // this.spancoFilterArray = _.uniqBy(this.enquiryData, 'spancoStage')
          this.spancoFilterArray = _.uniq(
            _.map(this.enquiryData, (a) => a.spancoStage)
          )
          // this.assignedToFilterArray = _.uniq(_.map(this.enquiryData, (a) => a.currentAssignedTo))

          this.dataStore = this.enquiryData

          this.total = this.filterData.length
          this.isLoading = false
          this.skeletonLoaderFlag = false
        }
      } catch (e) {
        this.skeletonLoaderFlag = false
        this.isLoading = false
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        return this.$dialog.error({
          text: errorMessage,
          title: 'Error'
        })
      }
    },
    getEnquiryStages: async function () {
      try {
        this.isLoading = true
        let { data } = await http.get(
          `${constants.API_URL}/api/getEnquiryStages`
        )
        this.subStageArray = data
        this.subStageArray = _.filter(this.subStageArray, (a) => {
          if (a.statusName !== 'Enquiry') {
            return a
          }
        })
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.$dialog.error({
          text: errorMessage,
          title: 'Error'
        })
      } finally {
        this.isLoading = false
      }
    },
    getEnquiryAssignee: async function () {
      try {
        this.isLoading = true
        let { data } = await http.get(
          `${constants.API_URL}/api/enquiry-assignee`
        )
        this.assignedToFilterArray = data
        this.assignedToFilterArray = _.filter(
          _.map(this.assignedToFilterArray, (o) => {
            return o.user
          }),
          (a) => {
            return a
          }
        )
        this.assignedToFilterArray = _.map(this.assignedToFilterArray, (a) => {
          a.displayName = a.firstName + ' ' + a.lastName
          return a
        })
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.$dialog.error({
          text: errorMessage,
          title: 'Error'
        })
      } finally {
        this.isLoading = false
      }
    },
    getResults: async function () {
      try {
        if (this.franchiseeID) {
          const { data } = await http.post(
            `${constants.API_URL}/api/search-enquiry/`,
            {
              franchiseeID: this.franchisee.id,
              academicYearID: this.academicYearID,
              searchType: this.findEnquiry.searchType,
              searchKey: this.findEnquiry.searchKey
            }
          )
          this.enquiryTableData = data
          // if (this.enquiryTableData) {
          //   this.mobileDataHeight = 1500
          // } else if (this.enquiryTableData.length > 40) {
          //   this.mobileDataHeight = 4000
          // }
          this.downEnquiry = data.rows
          this.enquiryTableData.filter((item, index) => {
            item.srno = index + 1
            let spancoName = item.spancoStatus
              ? item.spancoStatus
              : this.spancoDefaultStatus
            let spancoStg = item.enquiryStage
              ? item.enquiryStage.name
              : this.spancoDefaultStage
            item.spancoStage = spancoName + ' - ' + spancoStg
            item.dateOfEnquiry = moment(item.dateOfEnquiry).format(
              'MMMM Do YYYY, HH:mm a'
            )
            item.createdAt = moment(item.createdAt).format(
              'MMMM Do YYYY, HH:mm a'
            )
            // item.followUpDate = moment(item.followUpDate).format(
            //   'MMMM Do YYYY, HH:mm a'
            // )
          })
          this.total = this.enquiryTableData.length
        }
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        console.log('error while searching enquiry data : ', errorMessage)
      }
    },
    spancoAssignFilter () {
      this.spancoArray = _.filter(this.subStageArray, (o) => {
        if (o.statusName === this.selectedSpancoStatus) {
          this.statusName = o.statusName
          return o
        }
      })
    },
    customFilter: function (searchTerm) {
      this.filterData = this.enquiryData
      if (_.isEmpty(searchTerm)) {
        this.filterData = this.enquiryData
      } else {
        let data = this.enquiryData
        if (this.radio === 'withMCBCode') {
          data = _.filter(data, 'enquiryCodeMCB')
        } else if (this.radio === 'withoutMCBCode') {
          data = _.filter(data, ['enquiryCodeMCB', null])
        }
        this.filterData = _.filter(
          data,
          (item) =>
            (item.fatherName &&
              item.fatherName
                .toLowerCase()
                .search(this.searchTerm.toLowerCase()) >= 0) ||
            (item.fatherMobile &&
              item.fatherMobile
                .toLowerCase()
                .search(this.searchTerm.toLowerCase()) >= 0) ||
            (item.franchiseeName &&
              item.franchiseeName
                .toLowerCase()
                .search(this.searchTerm.toLowerCase()) >= 0) ||
            (item.studentFirstName &&
              item.studentFirstName
                .toLowerCase()
                .search(this.searchTerm.toLowerCase()) >= 0) ||
            (item.studentLastName &&
              item.studentLastName
                .toLowerCase()
                .search(this.searchTerm.toLowerCase()) >= 0) ||
            (item.studentClass &&
              item.studentClass.name &&
              item.studentClass.name
                .toLowerCase()
                .search(this.searchTerm.toLowerCase()) >= 0) ||
            (item.franchisee &&
              item.franchisee.companyName
                .toLowerCase()
                .search(this.searchTerm.toLowerCase()) >= 0) ||
            (item.enquiryCodeMCB &&
              item.enquiryCodeMCB
                .toLowerCase()
                .search(this.searchTerm.toLowerCase()) >= 0) ||
            (item.utmSource &&
              item.utmSource
                .toLowerCase()
                .search(this.searchTerm.toLowerCase()) >= 0)
        )
      }

      this.total = this.filterData.length
    },
    getSourceName: function (sourceArray) {
      let sourceName = []
      if (sourceArray && sourceArray !== null && typeof sourceArray === 'object') {
        sourceArray.forEach(item => {
          if (item.name) {
            sourceName.push(item.name)
          }
        })
        if (sourceName.length > 0) {
          return sourceName.toString()
        } else {
          return '-'
        }
      }
      return '-'
    },
    resetAll: function () {
      const currentAcademicYear = Utils.getCurrentAcademicYear()
      let academicYear = this.academicYears.find((y) => {
        return y.academicYear.trim() === currentAcademicYear.trim()
      })
      this.filter = {
        fromDate: moment().format('YYYY-MM-DD'),
        toDate: moment().format('YYYY-MM-DD'),
        academicYearID: academicYear ? academicYear.id : '',
        stage: 'All'
      }
      this.selectedSpancoStatus = ''
      this.selectedSpancoName = ''
      this.search = ''
      this.assignedToFilterValue = ''
      this.classCategoryId = ''
      this.sourceCard = ''
      this.followUpSwitch = false
      this.enquiryTableData = []
      this.qrCodeUrl = ''

      this.getEnquiry()
    },
    async handlePageSizeChange (size) {
      if (this.isApply) {
        this.pageSize = size
        this.page = 1
        this.getEnquiry()
      } else {
        this.pageSize = size
        this.page = 1
        if (this.selectedSpancoStatus && this.selectedSpancoName) {
          await this.getEnquiryStagesReportFilter(this.selectedSpancoStatus, this.selectedSpancoName)
        } else if (this.selectedSpancoStatus) {
          await this.getEnquiryStagesReportFilter(this.selectedSpancoStatus, '')
        }
      }
    },
    async handlePageChange (value) {
      if (this.isApply) {
        this.page = value
        this.getEnquiry()
      } else {
        this.page = value
        if (this.selectedSpancoStatus && this.selectedSpancoName) {
          await this.getEnquiryStagesReportFilter(this.selectedSpancoStatus, this.selectedSpancoName)
        } else if (this.selectedSpancoStatus) {
          await this.getEnquiryStagesReportFilter(this.selectedSpancoStatus, '')
        }
      }
    },
    exportAllDataInCsv: async function () {
      try {
        this.isPaginationApply = false
        const filterData = {
          franchiseeID: this.franchisee.id,
          fromDate: this.filter.fromDate
            ? this.filter.fromDate
            : moment().format('YYYY-MM-DD'),
          toDate: this.filter.toDate
            ? this.filter.toDate
            : moment().format('YYYY-MM-DD'),
          academicYearID: this.academicYearID,
          stage: this.filter.stage,
          search: this.search,
          isPaginationApply: this.isPaginationApply
        }

        if (this.selectedSpancoStatus) {
          filterData.spancoStatus = this.selectedSpancoStatus
        }
        if (this.selectedSpancoName && this.selectedSpancoName !== 'All') {
          filterData.spancoName = this.spancoStage
        }
        if (this.assignedToFilterValue) {
          filterData.assignedToID = this.assignedToFilterValue
        }
        if (this.classCategoryId) {
          filterData.studentClassCategory = this.classCategoryId
        }

        if (this.getYetToCallAlertStripCount) {
          filterData.spancoStatus = 'Suspect'
          filterData.spancoName = 'Yet_to_Call'
          delete filterData.fromDate
          delete filterData.toDate
          this.spancoDefaultStatus = 'Suspect'
          this.spancoDefaultStage = 'Yet_to_Call'
          this.sourceCardAccess = true

          let url = `${constants.API_URL}/api/enquiry`
          const result = await http.get(url, {
            params: filterData
          })
          this.csvInfo = result.data.rows
        }

        if (this.getTodayFollowUpCount) {
          filterData.todaysFollowUpLead = true
          delete filterData.fromDate
          delete filterData.toDate
          this.sourceCardAccess = true

          let url = `${constants.API_URL}/api/enquiry`
          const result = await http.get(url, {
            params: filterData
          })
          this.csvInfo = result.data.rows
        }

        if (this.followUpSwitch) {
          filterData.franchiseeID = this.franchisee.id
          filterData.fromDate = this.filter.fromDate
            ? this.filter.fromDate
            : moment().format('YYYY-MM-DD')
          filterData.toDate = this.filter.toDate
            ? this.filter.toDate
            : moment().format('YYYY-MM-DD')
          filterData.academicYearID = this.academicYearID
          filterData.stage = this.filter.stage
          filterData.page = this.page - 1
          filterData.size = this.pageSize
          filterData.todaysFollowUpLead = false
          filterData.followupOnly = this.followUpSwitch
          let url = `${constants.API_URL}/api/enquiry`
          const result = await http.get(url, {
            params: filterData
          })
          this.csvInfo = result.data.rows
        }
        if (this.cardselected === false) {
          let url = `${constants.API_URL}/api/enquiry`
          const result = await http.get(url, {
            params: filterData
          })
          this.csvInfo = result.data.rows
        } else {
          if (this.academicYearID) {
            this.isLoading = true
            const formData = {
              academicYearID: this.academicYearID,
              franchiseeID: this.franchisee.id,
              spancoStatus: this.selectedSpancoStatus,
              subStatus: this.selectedSpancoName
            }
            let url = `${constants.API_URL}/api/getenquirystagesreportfilter?size=${this.totalItems}`
            const result = await http.post(url, formData)
            this.csvInfo = result.data.rows
          }
        }
        if (this.academicYearID) {
          this.isLoading = true
          this.csvInfo.forEach((Enq, index) => {
            Enq.srno = index + 1
            let spancoName = Enq.spancoStatus
              ? Enq.spancoStatus
              : this.spancoDefaultStatus
            let spancoStg = Enq.enquiryStage
              ? Enq.enquiryStage.name
              : this.spancoDefaultStage
            Enq.spancoStage = spancoName + ' - ' + spancoStg
            Enq.createdAt = moment(Enq.createdAt).format('D-MMM-YYYY HH:mm')
            Enq.updatedAt = moment(Enq.updatedAt).format('D-MMM-YYYY HH:mm')
            Enq.dateOfEnquiry = Enq.dateOfEnquiry
              ? moment(Enq.dateOfEnquiry).format('D-MMM-YYYY HH:mm')
              : '-'
            Enq.followUpDate = Enq.followUpDate
              ? moment(Enq.followUpDate).format('D-MMM-YYYY HH:mm')
              : '-'
            Enq.studentName = Enq.studentFirstName
            if (Enq.studentMiddleName) {
              Enq.studentName = Enq.studentName + ' ' + Enq.studentMiddleName
            }
            if (Enq.studentLastName) {
              Enq.studentName = Enq.studentName + ' ' + Enq.studentLastName
            }
            if (Enq.enquiryStage) {
              Enq.status = Enq.enquiryStage.name
            } else if (Enq.enrollmentCode) {
              Enq.status = 'Admission'
            } else if (Enq.ApplicationCode) {
              Enq.status = 'Application'
            } else {
              Enq.status = 'Enquiry'
            }
            Enq.currentAssignedTo = Enq.user
              ? Enq.user.firstName + ' ' + Enq.user.lastName
              : 'No user is assigned'

            Enq.OldEnquiryCode = Enq?.enquiryCodes?.[0]?.oldEnquiryCodes ? Enq.enquiryCodes[0].oldEnquiryCodes : '-'
          })
          this.exportToCSV()
          this.isLoading = false
        }
      } catch (e) {
        this.isLoading = false
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        return this.$dialog.error({
          text: errorMessage,
          title: 'Error'
        })
      }
    },
    exportToCSV () {
      const csvData = []
      this.csvInfo.forEach((t, index) => {
        csvData.push({
          SrNo: index + 1,
          EnquiryCode: t.enquiryCode,
          AssignedTo: t.assignedToID ? (t.user ? t.user.email : '') : '',
          ParentName: t.fatherName,
          StudentName: t.studentName,
          OptingClass: t.studentClass ? t.studentClass.name : '',
          ClassCategory: t.studentClass ? t.studentClass.category : '',
          // CenterName: t.franchiseeName ? t.franchiseeName : '',
          FranchiseeName: t.franchisee ? t.franchisee.companyName : '',
          Zone: t.franchisee ? t.franchisee.region : '',
          SpancoStatus: t.spancoStage,
          DateOfEnquiry: t.createdAt,
          NextFollowUp: t.followUpDate,
          OldEnquiryCode: t.OldEnquiryCode
        })
      })

      ExportUtility.convertToCsv(csvData, 'Enquiries')
    },
    resetEnquiry: function () {
      const currentAcademicYear = Utils.getCurrentAcademicYear()
      let academicYear = this.academicYears.find((y) => {
        return y.academicYear.trim() === currentAcademicYear.trim()
      })
      this.findEnquiry = {
        academicYearID: academicYear ? academicYear.id : '',
        searchType: 'studentmobile',
        searchKey: ''
      }
      this.enquiryTableData = ''
      this.toggleEnquiryModal()
      this.qrCodeUrl = ''
      this.isInput =
        this.mobileDataHeight = null
    },
    toggleEnquiryModal: function () {
      this.enableEnquiryModal = !this.enableEnquiryModal
    },
    generateQRcode: async function () {
      try {
        let opts = {
          errorCorrectionLevel: 'H',
          type: 'image/jpeg',
          quality: 1,
          margin: 3,
          color: {
            dark: this.qrCodeColor,
            light: '#FFF'
          },
          width: this.qrCodeWidth
        }
        let EnteredNumber = this.findEnquiry.searchKey
        if (this.franchiseeID) {
          let QRCodeString = null
          if (EnteredNumber) {
            QRCodeString = `${location.origin
            }/parent-enquiry/newentry/${Buffer.from(
              this.franchiseeID.toString()
            ).toString('base64')}/${EnteredNumber}`
          } else {
            QRCodeString = `${location.origin
            }/parent-enquiry/newentry/${Buffer.from(
              this.franchiseeID.toString()
            ).toString('base64')}`
          }
          this.qrCodeUrl = await QRCode.toDataURL(QRCodeString, opts)
        }
      } catch (e) {
        console.log(e)
      }
    },
    downloadQRcode: async function () {
      try {
        let opts = {
          errorCorrectionLevel: 'H',
          type: 'image/jpeg',
          quality: 1,
          margin: 3,
          color: {
            dark: this.qrCodeColor,
            light: '#FFF'
          },
          width: this.qrCodeWidth
        }
        if (this.franchiseeID) {
          let QRCodeString = `${location.origin
          }/parent-enquiry/newentry/${Buffer.from(
            this.franchiseeID.toString()
          ).toString('base64')}`

          this.qrCodeUrl = await QRCode.toDataURL(QRCodeString, opts)
        }
      } catch (e) {
        console.log(e)
      } finally {
        const url = this.qrCodeUrl
        const a = document.getElementById('download')
        a.style.display = 'none'
        a.href = url
        // the filename you want
        a.download = 'QRcode'
        document.body.appendChild(a)
        a.click()
        window.URL.revokeObjectURL(url)
      }
    },
    studEnquiry: async function (e) {
      // e.target.value = e.target.value.replace(/[^0-9]+/g, '')
      try {
        if (
          typeof e === 'string' &&
          isNaN(e) &&
          this.findEnquiry.searchType === 'studentmobile'
        ) {
          return this.$dialog.error({
            text: 'Only Use Numbers',
            title: 'Error'
          })
        }
        if (
          (this.findEnquiry.searchType === 'studentname' &&
            this.findEnquiry.searchKey.length < 3) ||
          (this.findEnquiry.searchType === 'studentmobile' &&
            this.findEnquiry.searchKey.length < 3)
        ) {
          return
        }
        const { data } = await http.post(
          `${constants.API_URL}/api/search-enquiry/`,
          {
            franchiseeID: this.franchiseeID,
            academicYearID: this.academicYearID,
            searchType: this.findEnquiry.searchType,
            searchKey: this.findEnquiry.searchKey
          }
        )
        this.findData = data
        let nameArray = []
        if (this.findEnquiry.searchType === 'studentmobile') {
          nameArray = this.findData.map((i) => i.fatherMobile)
        } else {
          nameArray = this.findData.map((i) => i.studentFirstName)
        }
        this.findDataArr = await this.FilterResultData(nameArray)
        if (this.findDataArr) {
          this.mobileDataHeight = 400
        } else {
          this.mobileDataHeight = null
        }
        await this.getResults()
        if (this.enquiryTableData.length > 10) {
          this.mobileDataHeight = 1200
        } else if (this.enquiryTableData.length > 40) {
          this.mobileDataHeight = 4000
        }
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        return this.$dialog.error({
          text: errorMessage,
          title: 'Error'
        })
      }
    },
    FilterResultData: async function (resObj) {
      let result = resObj.filter((option) => {
        return option.indexOf(this.searchKey) >= 0
      })
      return result
    },
    passed: function () {
      if (_.isEmpty(this.enquiryTableData)) {
        this.$dialog.notify.info(
          'Record You are Searching for is not found. please create new entry',
          {
            color: 'warning',
            position: 'top-right',
            timeout: 5000
          }
        )
        if (this.findEnquiry.searchType === 'studentmobile') {
          this.$router.push({
            name: 'enquiryForm',
            params: {
              fatherMobiles: this.findEnquiry.searchKey,
              franchisee: this.franchisee.id
            }
          })
        } else {
          this.$router.push({
            name: 'enquiryForm',
            params: {
              studentName: this.findEnquiry.searchKey,
              franchisee: this.franchisee.id
            }
          })
        }
      } else if (
        this.findEnquiry.searchKey === '' &&
        this.findEnquiry.searchType === 'studentmobile'
      ) {
        this.$dialog.message.info('Enter Mobile Number', {
          position: 'top',
          timeout: 5000
        })
      } else if (
        this.findEnquiry.searchKey === '' &&
        this.findEnquiry.searchType === 'studentname'
      ) {
        this.$buefy.toast.open({
          message: 'Enter Student Name',
          queue: false,
          type: 'is-danger'
        })
        this.$dialog.message.info('Enter Student Name', {
          position: 'top',
          timeout: 5000
        })
      } else if (this.findData.length > 0) {
        this.getResults()
      } else if (
        (this.findEnquiry.searchType === 'studentname' &&
          this.findEnquiry.searchKey.length < 3) ||
        (this.findEnquiry.searchType === 'studentmobile' &&
          this.findEnquiry.searchKey.length < 10)
      ) {
        // this.alertFunction()
      } else {
        if (this.findEnquiry.searchType === 'studentmobile' && this.enquiryTableData.length < 0) {
          this.$router.push({
            name: 'enquiryForm',
            params: {
              fatherMobiles: this.findEnquiry.searchKey,
              franchisee: this.franchisee.id
            }
          })
        }
      }
    }
  }
}
</script>
